import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import userRoles from "../../configs/userRolesConfigs";
import UploadFileBtn from "../Helper/UploadFileBtn/UploadFileBtn";
import { uploadReports } from "./ReportsUtils";
import "./UploadReports.scss";

const UploadReports = () => {
  const dispatch = useDispatch();

  let defaultAccount = useSelector(
    (state: any) => state.account.default_account
  );
  const [response, setResponse] = useState(null);

  let userRole = useSelector((state: any) => state.general.userRol);

  useEffect(() => {
  }, []);

  const uploadReportFiles = async (files) => {
    setResponse(null);
    const response = await uploadReports(dispatch, files, defaultAccount.id);
    if (response && response['success_reports']) {
      setResponse(response);
    } else {
      alert('An error occurred');
    }
  }

  const responseRow = (title, files) => {
    return <div className="response-row">
      <span className="title-type">{title}: </span>
      {files.length && files.map(file => <span>{file}</span>)}
    </div>
  }

  return (
    <div>
      <h2>Upload Reports</h2>
      <Box className="w-100">
        {(userRole === userRoles.admin || userRole === userRoles.analyst) && (
          <Box mb={3}>
            <UploadFileBtn
              onSubmit={uploadReportFiles}
              multiple={true}
              exdendStyle={true}
              classes="m-auto"
              title="Upload Reports"
              fileType="excel"
              buttonText="Upload"
            ></UploadFileBtn>
          </Box>
        )}
        {(response && <div className="response">
          {responseRow('Success', response['success_reports'])}
          {responseRow('Error', response['error_reports'])}
          {responseRow('Blank reports', response['empty_reports'])}
          {responseRow('Unknown Report type', response['unknown_reports'])}
          {responseRow('Invalid Account of Report', response['invalid_account_reports'])}
        </div>)}
      </Box>

    </div>
  );
};

export default UploadReports;
